import React from 'react';
import { SignUpWrapper } from './SignUpWrapper';
import RegisterUserFormContainer from '../../FormContainers/Authentication/RegisterUserForm';
import { RegisterUserForm } from '../../../Components/forms/AuthenticationForms/RegisterUser';
import { getQueryParam } from '../../../../Utils';
import { parseBranchIOLink } from '../../../../Utils/branchIOHelper';

export class RegisterUser extends React.Component {
    state = {
        invitationCode: null,
    };
    componentDidMount() {
        parseBranchIOLink().then(data => {
            if (data && data.data_parsed && data.data_parsed.code)
                this.setState({ invitationCode: data.data_parsed.code });
        });
    }

    render() {
        const { location } = this.props;
        const { invitationCode } = this.state;

        const prefilledFields = {
            email: getQueryParam(location.search, 'email'),
            fullName: getQueryParam(location.search, 'fullname'),
            invitationCode,
        };

        return (
            <SignUpWrapper
                title={'Sign up to Tona'}
                subtitle={'Create a free account and join the world’s best fitness community.'}
            >
                <RegisterUserFormContainer {...prefilledFields} renderForm={props => <RegisterUserForm {...props} />} />
            </SignUpWrapper>
        );
    }
}

RegisterUser.defaultProps = {
    location: {},
};



// WEBPACK FOOTER //
// ./src/UI/Containers/Authentication/SignUp/RegisterUser.js